<!-- Contenedor principal centrado con padding responsive -->
<div class="w-full min-h-screen flex items-center justify-center px-2 sm:px-4" style="padding: 20px 8px;">
    <div #chatSection
        class="flex h-[540px] md:h-[630px] lg:h-[410px] xl:h-[610px] antialiased text-gray-800 w-full max-w-4xl">
        <div class="flex flex-row h-full w-full overflow-x-hidden rounded-xl sm:rounded-3xl shadow-xl shadow-gray-300">
            <!-- Sección chat -->
            <div class="flex flex-col flex-auto h-full z-30">
                <!-- Título del chat -->
                <div class="rounded-t-xl sm:rounded-t-3xl sticky top-0 z-50 bg-verde3">
                    <h4
                        class="font-semibold font-serif text-lg sm:text-[25px] xl:text-[30px] leading-[1.2] aos-init aos-animate text-white p-3 sm:p-5">
                        CHAT TASA
                    </h4>
                </div>

                <div class="flex flex-col flex-auto h-0 overflow-y-auto p-1">

                    <!-- ! Area de mensajes -->
                    <div class="flex flex-col h-full overflow-y-auto" #chatbox>
                        <div class="flex flex-col h-full">
                            <ng-container *ngFor="let msg of messages">
                                <div class="grid grid-cols-12 gap-y-1 sm:gap-y-2">
                                    <!-- Si el mensaje es del usuario -->
                                    <div *ngIf="msg.sender === 'user'"
                                        class="col-start-2 sm:col-start-3 md:col-start-6 col-end-13 p-2 sm:p-3 rounded-lg">
                                        <div class="flex items-center justify-start flex-row-reverse">
                                            <div
                                                class="relative mr-2 sm:mr-3 text-sm sm:text-base bg-white py-2 px-3 sm:px-4 shadow rounded-s-xl rounded-ee-xl break-words overflow-wrap-anywhere">
                                                <!-- Información del archivo, si existe -->
                                                <div *ngIf="msg.file"
                                                    class="mb-2 bg-orange-100 rounded-lg p-2 sm:p-3 border border-orange-300 flex items-center space-x-2 sm:space-x-4">
                                                    <div
                                                        class="flex items-center justify-center h-8 w-8 sm:h-12 sm:w-12 bg-orange-300 rounded-lg text-white">
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            class="h-4 w-4 sm:h-6 sm:w-6" fill="none"
                                                            viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                                        </svg>
                                                    </div>
                                                    <div class="flex-1">
                                                        <p class="text-xs sm:text-sm font-semibold text-orange-700">⚠️
                                                            Archivo no procesado</p>
                                                        <p class="text-xs text-orange-600">N8N no soporta archivos</p>
                                                        <p class="text-xs text-orange-500">{{ msg.file.name.length > 15
                                                            ? (msg.file.name | slice:0:15) + '...' : msg.file.name }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <!-- Mensaje del usuario -->
                                                <span [innerHTML]="msg.message"></span>

                                                <!-- ⭐ TIMESTAMP DEL USUARIO -->
                                                <div *ngIf="msg.timestamp"
                                                    class="timestamp text-xs font-medium text-gray-400 mt-1 text-right">
                                                    {{ msg.timestamp | date:'shortTime' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Si el mensaje es del bot -->
                                    <div *ngIf="msg.sender === 'bot'"
                                        class="col-start-1 col-end-12 md:col-end-11 p-2 sm:p-3 rounded-lg">
                                        <div class="flex flex-row items-start">
                                            <div
                                                class="flex items-center justify-center h-6 w-6 sm:h-7 sm:w-7 lg:h-10 lg:w-10 rounded-full flex-shrink-0 bg-gradient-to-b from-[#1d8549] to-[#124734]">
                                                <img src="assets/images/burbujaLogGobAnt.png" class=""
                                                    alt="service-icon" style="height: 100%; width: 100%;" />
                                            </div>
                                            <div
                                                class="relative ml-2 sm:ml-3 text-sm sm:text-base bg-white py-2 px-3 sm:px-4 shadow rounded-e-xl rounded-es-xl break-words overflow-hidden max-w-full">
                                                <span [innerHTML]="msg.message"></span>

                                                <!-- ========== REPRODUCTOR DE AUDIO SIMPLE ========== -->
                                                <div *ngIf="msg.audio && msg.audioUrl"
                                                    class="mt-2 p-2 bg-gray-50 rounded-lg border-t border-gray-200">
                                                    <div class="flex items-center space-x-2">
                                                        <!-- Reproductor básico -->
                                                        <audio controls class="flex-1 h-8" style="max-width: 250px;">
                                                            <source [src]="msg.audioUrl" type="audio/mpeg">
                                                            <source [src]="msg.audioUrl" type="audio/wav">
                                                            <source [src]="msg.audioUrl" type="audio/ogg">
                                                            Tu navegador no soporta audio.
                                                        </audio>
                                                    </div>
                                                </div>

                                                <!-- ⭐ TIMESTAMP DEL BOT -->
                                                <div *ngIf="msg.timestamp"
                                                    class="timestamp text-xs font-medium text-gray-500 mt-1">
                                                    {{ msg.timestamp | date:'shortTime' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Indicador de "pensando" -->
                            <div *ngIf="isThinking" class="grid grid-cols-12 gap-y-1 sm:gap-y-2">
                                <div class="col-start-1 col-end-8 p-2 sm:p-3 rounded-lg">
                                    <div class="flex flex-row items-start">
                                        <div
                                            class="flex items-center justify-center h-6 w-6 sm:h-7 sm:w-7 lg:h-10 lg:w-10 rounded-full bg-gradient-to-b from-[#1d8549] to-[#124734]">
                                            <img src="assets/images/burbujaLogGobAnt.png" class="" alt="service-icon"
                                                style="height: 100%; width: 100%;" />
                                        </div>
                                        <div
                                            class="relative ml-2 sm:ml-3 text-sm sm:text-base bg-white py-2 px-3 sm:px-4 shadow rounded-e-xl rounded-es-xl h-[30px] sm:h-[36px] flex items-center">
                                            <div class="loader"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ! Área de input y botón -->
                    <div
                        class="bg-gray-50 z-50 sticky bottom-0 rounded-b-xl sm:rounded-b-3xl p-2 sm:p-4 overflow-hidden">
                        <!-- Archivo seleccionado -->
                        <div *ngIf="selectedFile"
                            class="bg-orange-100 rounded-lg p-2 sm:p-3 mb-2 border border-orange-300 flex items-center space-x-2 sm:space-x-4">
                            <div
                                class="flex items-center justify-center h-8 w-8 sm:h-12 sm:w-12 bg-orange-300 rounded-lg text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-6 sm:h-6" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                </svg>
                            </div>
                            <div class="flex items-center justify-between w-full flex-wrap gap-1 sm:gap-2">
                                <div class="flex-1 min-w-0">
                                    <p class="text-xs sm:text-sm font-semibold text-orange-700">⚠️ Archivo no será
                                        procesado
                                    </p>
                                    <p class="text-xs text-orange-600">N8N solo acepta mensajes de texto</p>
                                    <p class="text-xs text-orange-500">{{ selectedFile.name.length > 15 ?
                                        (selectedFile.name
                                        | slice:0:15) + '...' : selectedFile.name }}</p>
                                </div>
                                <button type="button" (click)="clearFile()"
                                    class="flex-shrink-0 inline-flex items-center justify-center text-orange-600 hover:text-orange-800 text-sm focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        class="sm:w-6 sm:h-6">
                                        <path fill="none" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" stroke-width="1.5"
                                            d="M14 11v6m-4-6v6M6 7v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7M4 7h16M7 7l2-4h6l2 4" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- ========== CONTROLES DE INPUT ========== -->
                        <div class="relative flex items-center gap-1 sm:gap-2 overflow-hidden"
                            style="height: 38px; min-height: 38px; max-height: 38px;">

                            <!-- ========== BOTÓN AUDIO ========== -->
                            <button type="button" (click)="toggleSpeak()"
                                class="inline-flex items-center justify-center rounded-full h-8 w-8 transition duration-300 ease-in-out focus:outline-none flex-shrink-0"
                                [ngClass]="{
                                'text-verde1 hover:text-verde2': speak,
                                'text-gray-400 hover:text-gray-600': !speak
                            }" [title]="speak ? 'Desactivar audio' : 'Activar audio'">
                                <img *ngIf="speak" src="assets/icons/home/volume_up.svg" alt="Audio activado"
                                    class="w-5 h-5 sm:w-6 sm:h-6"
                                    [ngStyle]="{ 'filter': 'invert(57%) sepia(93%) saturate(314%) hue-rotate(76deg) brightness(90%) contrast(92%)' }" />
                                <img *ngIf="!speak" src="assets/icons/home/volume_off.svg" alt="Audio desactivado"
                                    class="w-5 h-5 sm:w-6 sm:h-6" />
                            </button>

                            <!-- ========== BOTÓN MICRÓFONO ========== -->
                            <button type="button" (click)="toggleRecording()"
                                class="inline-flex items-center justify-center rounded-full h-8 w-8 transition duration-300 ease-in-out focus:outline-none relative flex-shrink-0"
                                [ngClass]="{
                                'cursor-not-allowed opacity-50': !inputOn || isProcessingMic || isWaitingForAIResponse || isThinking || isTyping,
                                'cursor-pointer': inputOn && !isProcessingMic && !isWaitingForAIResponse && !isThinking && !isTyping
                            }"
                                [disabled]="!inputOn || isProcessingMic || isWaitingForAIResponse || isThinking || isTyping">

                                <span *ngIf="isRecording"
                                    class="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping"></span>

                                <div *ngIf="!inputOn || isWaitingForAIResponse || isThinking || isTyping"
                                    class="opacity-50 relative z-10">
                                    <img src="assets/icons/home/mic.svg" alt="Micrófono no disponible"
                                        class="w-5 h-5 sm:w-6 sm:h-6" [ngStyle]="{ 'filter': 'grayscale(100%)' }" />
                                </div>

                                <div *ngIf="inputOn && !isRecording && !isWaitingForAIResponse && !isThinking && !isTyping"
                                    class="relative z-10">
                                    <img src="assets/icons/home/mic.svg" alt="Micrófono listo"
                                        class="w-5 h-5 sm:w-6 sm:h-6"
                                        [ngStyle]="{ 'filter': 'invert(57%) sepia(93%) saturate(314%) hue-rotate(76deg) brightness(90%) contrast(92%)' }" />
                                </div>

                                <div *ngIf="inputOn && isRecording && !isWaitingForAIResponse && !isThinking && !isTyping"
                                    class="relative z-10">
                                    <img src="assets/icons/home/settings_voice.svg" alt="Grabando..."
                                        class="w-5 h-5 sm:w-6 sm:h-6"
                                        [ngStyle]="{ 'filter': 'invert(24%) sepia(97%) saturate(7456%) hue-rotate(359deg) brightness(105%) contrast(108%)' }" />
                                </div>
                            </button>

                            <!-- ========== BOTÓN CANCELAR GRABACIÓN ========== -->
                            <button *ngIf="isRecording" type="button" (click)="cancelRecording()"
                                class="inline-flex items-center justify-center rounded-full h-8 w-8 bg-red-500 hover:bg-red-600 transition duration-300 ease-in-out focus:outline-none flex-shrink-0 shadow-md"
                                title="Cancelar grabación">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>

                            <!-- ========== ÁREA DE INPUT ========== -->
                            <div class="flex-1 relative overflow-hidden" style="height: 38px;">

                                <!-- Mensaje de grabación -->
                                <div *ngIf="isRecording"
                                    class="absolute inset-0 flex items-center justify-center bg-red-50 border-2 border-red-400 rounded-xl px-2 sm:px-4">
                                    <div class="flex items-center gap-2 whitespace-nowrap">
                                        <span
                                            class="w-2 h-2 bg-red-500 rounded-full animate-pulse flex-shrink-0"></span>
                                        <span class="text-red-600 font-semibold text-xs sm:text-sm flex-shrink-0">
                                            Grabando: {{ recordingTime }}s
                                        </span>
                                        <span
                                            class="text-red-400 text-[10px] sm:text-xs hidden sm:inline flex-shrink-0">
                                            Toca para detener
                                        </span>
                                    </div>
                                </div>

                                <!-- Textarea -->
                                <textarea *ngIf="!isRecording" #messageInput
                                    placeholder="Escribe tu consulta sobre TASA aquí..." [(ngModel)]="newMessageUser"
                                    name="message" (keypress)="handleKeyPress($event)"
                                    class="block w-full h-full text-sm border rounded-xl border-verde1 hover:border-azul focus:outline-none focus:border-verde3 px-3 py-2 resize-none"
                                    rows="1" [disabled]="!inputOn" [maxlength]="MAX_MESSAGE_LENGTH"
                                    style="overflow-x: hidden; overflow-y: auto; line-height: 1.5;">
                            </textarea>
                            </div>

                            <!-- ========== BOTÓN ENVIAR ========== -->
                            <button type="submit"
                                [disabled]="!canSendMessage() || isRecording || newMessageUser.trim() === ''"
                                class="inline-flex items-center justify-center rounded-full text-white bg-verde1 hover:bg-verde2 h-8 w-8 transition-all duration-300 flex-shrink-0"
                                [ngClass]="{
        'cursor-not-allowed bg-[#cecece] hover:bg-[#cecece]': !canSendMessage() || isRecording || newMessageUser.trim() === ''
    }" (click)="sendMessage()">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24">
                                    <path fill="white"
                                        d="m6.998 10.247l.435.76c.277.485.415.727.415.993s-.138.508-.415.992l-.435.761c-1.238 2.167-1.857 3.25-1.375 3.788c.483.537 1.627.037 3.913-.963l6.276-2.746c1.795-.785 2.693-1.178 2.693-1.832s-.898-1.047-2.693-1.832L9.536 7.422c-2.286-1-3.43-1.5-3.913-.963s.137 1.62 1.375 3.788" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
